var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sensorList),function(sensor){return _c('span',{key:sensor.id},[(sensor.code)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v("\n      "+_vm._s(sensor.code)+" -\n      "+_vm._s(sensor.two_name == '' ? sensor.name : sensor.two_name))]):_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(sensor))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }